// import Vue from 'vue'
import { createStore } from 'vuex'
import storage from '@/common/storage'
const state = {
    modalStatus: {
        mode: 'Login', // or 'register',
        visible: false
    },
    userInfo: storage.get('CodeAC_userInfo'),
    token: localStorage.getItem('CodeAC_token'),
    loginFailNum: 0,
    unreadMessage: {
        comment: 0,
        reply: 0,
        like: 0,
        sys: 0,
        mine: 0
    }
}
export default createStore({
    state: state,
    getters: {
        userInfo: state => state.userInfo || {},
        token: state => state.token ||'',
        isLogin: (state, getters) => {return !!getters.token},
    },
    mutations: {
        changeUserInfo(state, {userInfo}) {
            state.userInfo = userInfo;
            localStorage.setItem('CodeAC_userInfo',userInfo);
        },
        changeUserToken(state, token){
            state.token = token
            localStorage.setItem("CodeAC_token",token)
        },
        clearUserInfoAndToken(state){
            state.token = ''
            state.userInfo = {}
            state.loginFailNum = 0
            storage.clear()
        },
    },
    actions: {
        setUserInfo ({commit}, userInfo) {
            commit('changeUserInfo', {
              userInfo: userInfo
            })
        },
        clearUserInfoAndToken ({commit}) {
          commit('clearUserInfoAndToken')
        },
    },
    modules: {

    }
})
